import { useSelector } from "react-redux";
import { T } from "react-translator-component";
import { colors } from "../../../common/colors";
import { useAppDispatch } from "../../../redux/store";
import { setItem } from "../../redux/createOpinionReducer";
import Section from "../editors/Section";
import DropDown from "../DropDown";

interface Props {
  groups: any[]
}

export default function SelectGroup({ groups }: Props) {
  const dispatch = useAppDispatch();

  const group = useSelector((state: any) => state.createOpinion.values.group);
  const error = useSelector((state: any) => state.createOpinion.errors.group);

  return (
    <Section
      title={`${T("group")}${T("required")}`}
      body={(
        <DropDown
          sx={{
            marginTop: 2,
            width: "100%",
            justifyContent: "left",
            backgroundColor: colors.farm_white,
          }}
          title={T("group")}
          options={groups}
          value={group}
          errorMessage={error}
          onChange={(e) => dispatch(setItem({key: 'group', value: String(e.target.value)}))}
        />
      )}
    />
  )
}
